export function existsSport(data, sportId) {
    return data?.sportById?.[sportId];
}
